import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PmadminService {
  
  constructor() { }
  private userChangeSuccess: Subject<any> = new Subject<any>();
  private newUserPopup: Subject<any> = new Subject<any>();
  private openEditPopup: Subject<any> = new Subject<any>();
  private userId: string = '';

  queueSuccessMessage(){
    this.userChangeSuccess.next();
  }

  getSuccessMessage(){
    return this.userChangeSuccess.asObservable();
  }

  closeNewUserPopup(){
    this.newUserPopup.next();
  }

  getCloseNewUserPopup(){
    return this.newUserPopup.asObservable();
  }

  openEdit(){
    this.openEditPopup.next();
  }
  
  getOpenEditPopup(){
    return this.openEditPopup.asObservable();
  }

  setUserId(userId: string){
    this.userId = userId;
  }

  getUserId(){
    return this.userId;
  }
}
